import { queryOptions } from "@tanstack/react-query";
import { api, unwrap } from "@/shared/lib/apiClient";
import { overviewKeys } from "@/shared/lib/queryKeys";
import { MAX_WINDOW_DAYS } from "../attendance.config";

// Always fetches the max window; the grid renders the visible prefix, so resizing never refetches.
export function overviewQueryOptions(startIso: string) {
  return queryOptions({
    queryKey: [...overviewKeys.all, startIso, MAX_WINDOW_DAYS],
    queryFn: async () =>
      unwrap(
        await api.GET("/api/overview", {
          params: { query: { start: startIso, days: MAX_WINDOW_DAYS } },
        }),
      ),
  });
}
